{
  "version": 1,
  "asset_id": "04da11f8-497d-4348-b1a8-22bdd8c46606",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/04da11f8-497d-4348-b1a8-22bdd8c46606/dirty-stamped-concrete.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/04da11f8-497d-4348-b1a8-22bdd8c46606/dirty-stamped-concrete.mp4",
  "original_filename": "dirty-stamped-concrete.mp4",
  "size": 4871713,
  "content_type": "video/mp4",
  "created_at": "2026-09-11T23:20:13Z"
}
